import { QRCodeCanvas } from "qrcode.react";
import "./liquid-glass.css";
import "./Hero.css";
import Motif from "../assets/motif.svg";
import Play_Store_Button_Image from "../assets/Play_Store_Button_Img.svg";
import App_Store_Button_Image from "../assets/App_Store_Button_Img.svg";
import LegalLinks from "./LegalLinks";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.bolo.india";
const APP_STORE_URL =
  "https://apps.apple.com/in/app/bolo-india-media/id6781571060";
const DOWNLOAD_URL = "https://boloindia.com/download-app";

export default function Hero() {
  const open = (url) => window.open(url, "_blank", "noopener,noreferrer");

  return (
    <section className="hero">
      <div className="hero__content glass-panel">
        <h1 className="hero__title">
          Presenting India
          <br />
          <span className="hero__title-accent">to the World.</span>
        </h1>

        <p className="hero__subtitle">
          Bolo India is a sovereign social media platform, made in India for
          every Indian voice — news, culture, opinions, towns and communities
          — built to let you connect, share, and be heard across India and
          the World.
        </p>

        <div className="hero__get">
          <div className="hero__qr">
            <QRCodeCanvas
              value={DOWNLOAD_URL}
              size={132}
              level="H"
              includeMargin={false}
              bgColor="#ffffff"
              fgColor="#000000"
            />
          </div>

          <div className="hero__get-side">
            <p className="hero__get-hint">
              Scan to download, or get it from your store
            </p>
            <div className="hero__stores">
              <button
                className="hero__store"
                type="button"
                onClick={() => open(PLAY_STORE_URL)}
                aria-label="Get Bolo India on Google Play"
              >
                <img src={Play_Store_Button_Image} alt="Get it on Google Play" />
              </button>
              <button
                className="hero__store"
                type="button"
                onClick={() => open(APP_STORE_URL)}
                aria-label="Download Bolo India on the App Store"
              >
                <img
                  src={App_Store_Button_Image}
                  alt="Download on the App Store"
                />
              </button>
            </div>
          </div>
        </div>

        <img className="hero__motif" src={Motif} alt="" aria-hidden="true" />

        <p className="hero__made-in-india">Proudly Made in India</p>
      </div>

      <LegalLinks />
    </section>
  );
}
